import { render, staticRenderFns } from "./CourseRelatedItem.vue?vue&type=template&id=4b1e0d59&scoped=true&"
import script from "./CourseRelatedItem.vue?vue&type=script&lang=js&"
export * from "./CourseRelatedItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseRelatedItem.vue?vue&type=style&index=0&id=4b1e0d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e0d59",
  null
  
)

export default component.exports